import React, { useMemo } from "react"
import { zxcvbn, zxcvbnOptions } from "@zxcvbn-ts/core"
import * as zxcvbnCommonPackage from "@zxcvbn-ts/language-common"
import * as zxcvbnEnPackage from "@zxcvbn-ts/language-en"

const options = {
  translations: zxcvbnEnPackage.translations,
  graphs: zxcvbnCommonPackage.adjacencyGraphs,
  dictionary: {
    ...zxcvbnCommonPackage.dictionary,
    ...zxcvbnEnPackage.dictionary,
  },
}
zxcvbnOptions.setOptions(options)

const STRENGTH_MAP = [
  { label: "too weak", color: "#F5222D" },
  { label: "weak", color: "#FA8C16" },
  { label: "fair", color: "#FADB14" },
  { label: "strong", color: "#52C41A" },
  { label: "very strong", color: "#1890FF" },
]

export function getPasswordStrength(password) {
  if (!password) return { score: 0, label: "", color: "" }

  const result = zxcvbn(password)
  const { label, color } = STRENGTH_MAP[result.score]
  return { score: result.score + 1, label, color }
}

export function isPasswordStrong(password) {
  const { score } = getPasswordStrength(password)
  return score >= 3
}

export default function PasswordStrengthMeter({ password }) {
  const strength = useMemo(() => getPasswordStrength(password), [password])
  const totalBars = 5

  if (!password) return null

  return (
    <div className="password-strength-meter">
      <div className="password-strength-bars">
        {Array.from({ length: totalBars }).map((_, i) => (
          <div
            key={i}
            className="password-strength-bar"
            style={{
              backgroundColor: i < strength.score ? strength.color : "#E8E8E8",
            }}
          />
        ))}
      </div>
      <div
        className="password-strength-label"
        style={{ color: strength.color ,marginTop: "4px"}}
      >
        {strength.label}
      </div>
    </div>
  )
}
